import React, { Component } from 'react';
import StepperItemLayout from '../StepperItemLayout';
import './styles.css';

class StepperItem extends Component {
	renderNumber(lastSubmission) {
		switch (lastSubmission) {
		case 1:
			return (
				<span>
						1<small>st</small>
				</span>
			);
		case 2:
			return (
				<span>
						2<small>nd</small>
				</span>
			);
		case 3:
			return (
				<span>
						3<small>rd</small>
				</span>
			);
		}
	}
	render() {
		const { active, missing, submission, businessPlanID, game } = this.props;
		const {
			DarkGreyCircle,
			LightGreyCircle,
			GreenCentralCircle,
			GreyCentralCircle,
			RedCentralCircle,
			Label,
			Button
		} = StepperItemLayout;
		return (
			<div className="stepper-item">
				<StepperItemLayout>
					<DarkGreyCircle>
						<LightGreyCircle>
							{active ? (
								<GreenCentralCircle />
							) : missing ? (
								<RedCentralCircle />
							) : (
								<GreyCentralCircle />
							)}
						</LightGreyCircle>
					</DarkGreyCircle>
					<Label>{this.renderNumber(submission)} Submission</Label>
					{active && (
						<Button businessPlanID={businessPlanID} gameID={game.id} />
					)}
				</StepperItemLayout>
			</div>
		);
	}
}

export default StepperItem;
